const ADD_DIALOG = '[data-tour="user-management-add-user-diaglog"]';
const EXPORT_BTN = '[data-tour="user-management-export-button"]';
const RESTORE_BTN = '[data-tour="user-management-restore-button"]';
const RESTORE_DIALOG = '[data-tour="user-management-restore-dialog"]';
const RESTORE_TABLE = '[data-tour="user-management-restore-table"]';
const RESTORE_SEND_BTN = '[data-tour="user-management-restore-send-button"]';
const INVITE_BTN = '[data-tour="user-management-invite-button"]';
const INVITE_DIALOG = '[data-tour="user-management-invite-dialog"]';
const INVITE_TABLE = '[data-tour="user-management-invite-table"]';
const INVITE_NEW_USER_BTN = '[data-tour="user-management-invite-new-user-button"]';
const INVITE_NEW_USER_DIALOG = '[data-tour="user-management-invite-new-user-dialog"]';
const INVITE_NEW_USER_INPUT = '[data-tour="user-management-invite-new-user-input"]';
const INVITE_NEW_USER_TABLE = '[data-tour="user-management-invite-new-user-table"]';
const INVITE_NEW_USER_SEND = '[data-tour="user-management-invite-new-user-send"]';
const EDIT_BTN = '[data-tour="user-management-edit-button"]';
const EDIT_DIALOG = '[data-tour="user-management-edit-dialog"]';
const SHOW_EVENT_BTN = '[data-tour="user-management-show-event-button"]';
const TERMINATE_BTN = '[data-tour="user-management-terminate-button"]';
const REMOVE_BTN = '[data-tour="user-management-remove-button"]';
const DETAIL_TAB = '[data-tour="user-management-detail-tab"]';
const DEVICE_TAB = '[data-tour="user-management-device-tab"]';
const USERGROUP_TAB = '[data-tour="user-management-usergroup-tab"]';
const LEAVE_TAB = '[data-tour="user-management-leave-tab"]';

const openAdvancedMenu = () => window.__openAdvancedMenu?.();
const closeAdvancedMenu = () => window.__closeAdvancedMenu?.();
const closeRestoreDialog = () => window.__closeRestoreDialog?.();
const openInviteDialog = () => {
  closeAdvancedMenu();
  closeRestoreDialog();
  window.__openInviteDialog?.();
};
const closeInviteDialog = () => window.__closeInviteDialog?.();
const closeInviteNewUserDialog = () => window.__closeInviteNewUserDialog?.();
const closeEditUserDialog = () => window.__closeEditUserDialog?.();
const closeUserStatusMenu = () => window.__closeUserStatusMenu?.();

/** Mở CreateUserFromDeletedUsersDialog (đóng advanced menu trước) */
const openRestoreDialogFlow = () => {
  closeAdvancedMenu();
  closeInviteNewUserDialog();
  closeInviteDialog();
  window.__openRestoreDialog?.();
};

/** Chờ window handler được đăng ký sau khi dialog cha mount */
const waitForWindowFn = (name, timeout = 2000) =>
  new Promise((resolve, reject) => {
    const start = Date.now();
    const tick = () => {
      if (typeof window[name] === "function") {
        resolve(window[name]);
        return;
      }
      if (Date.now() - start >= timeout) {
        reject(new Error(`${name} not ready`));
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });

const openInviteEmployeesFlow = () => {
  closeInviteNewUserDialog();
  openInviteDialog();
};

const openInviteNewUserFlow = async () => {
  openInviteDialog();
  try {
    const openFn = await waitForWindowFn("__openInviteNewUserDialog");
    openFn();
  } catch (e) {
    console.warn(e);
  }
};

const closeAllInviteFlow = () => {
  closeInviteNewUserDialog();
  closeInviteDialog();
  closeRestoreDialog();
};

/** Về tab Detail + đóng dialog/menu khác */
const goToDetailTab = () => {
  closeAllInviteFlow();
  closeEditUserDialog();
  closeUserStatusMenu();
  closeAdvancedMenu();
  window.__setUserInfoTab?.(0);
};

/** Mở edit dialog (isEdit) — đảm bảo đang ở tab Detail */
const openEditUserFlow = () => {
  closeAllInviteFlow();
  closeUserStatusMenu();
  window.__setUserInfoTab?.(0);
  window.__openEditUserDialog?.();
};

/** Mở status menu trên UserDetailTab (cần tab Detail) */
const openUserStatusMenuFlow = async () => {
  closeAllInviteFlow();
  closeEditUserDialog();
  window.__setUserInfoTab?.(0);
  try {
    const openFn = await waitForWindowFn("__openUserStatusMenu");
    openFn();
  } catch (e) {
    console.warn(e);
  }
};

const goToDeviceTab = () => {
  closeAllInviteFlow();
  closeEditUserDialog();
  closeUserStatusMenu();
  window.__setUserInfoTab?.(1);
};

const goToUserGroupTab = () => {
  closeAllInviteFlow();
  closeEditUserDialog();
  closeUserStatusMenu();
  window.__setUserInfoTab?.(2);
};

const goToLeaveTab = () => {
  closeAllInviteFlow();
  closeEditUserDialog();
  closeUserStatusMenu();
  window.__setUserInfoTab?.(3);
};

/** Employee: tab nằm ở UserInfoEmployeeRight (index khác admin) */
const goToEmployeeDeviceTab = () => window.__setEmployeeRightTab?.(0);
const goToEmployeeUserGroupTab = () => window.__setEmployeeRightTab?.(1);
const goToEmployeeLeaveTab = () => window.__setEmployeeRightTab?.(2);

/** Tour ngắn cho employee: Detail (left) + Devices / Groups / Leave (right) */
export const getUserManagementEmployeeTourSteps = (t) => [
  {
    selector: '[data-tour="drawer-user-management"]',
    content: t("tour.user-management.drawer"),
  },
  {
    selector: DETAIL_TAB,
    content: t("tour.user-management.detail-tab"),
    tourWaitFor: DETAIL_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: DEVICE_TAB,
    content: t("tour.user-management.device-tab"),
    tourOpen: goToEmployeeDeviceTab,
    tourWaitFor: DEVICE_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: USERGROUP_TAB,
    content: t("tour.user-management.usergroup-tab"),
    tourOpen: goToEmployeeUserGroupTab,
    tourWaitFor: USERGROUP_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: LEAVE_TAB,
    content: t("tour.user-management.leave-tab"),
    tourOpen: goToEmployeeLeaveTab,
    tourWaitFor: LEAVE_TAB,
    tourWaitFrames: 1,
  },
];

// Trả về steps theo hàm để hỗ trợ i18n (admin)
export const getUserManagementTourSteps = (t) => [
  {
    selector: '[data-tour="drawer-user-management"]',
    content: t("tour.user-management.drawer"),
  },
  {
    selector: '[data-tour="user-management-add-user-button"]',
    content: t("tour.user-management.add-user-button"),
  },
  {
    selector: ADD_DIALOG,
    content: t("tour.user-management.add-user-diaglog"),
    tourOpen: () => window.__openAddUserDialog?.(),
    tourWaitFor: ADD_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [ADD_DIALOG],
    resizeObservables: [ADD_DIALOG],
    actionAfter: () => {
      window.__closeAddUserDialog?.();
    },
  },
  {
    selector: '[data-tour="user-management-user-table"]',
    content: t("tour.user-management.user-table"),
    tourOpen: () => closeAdvancedMenu(),
  },
  // --- Advanced menu (Popper) ---
  {
    selector: EXPORT_BTN,
    content: t("tour.user-management.export-button"),
    tourOpen: openAdvancedMenu,
    tourWaitFor: EXPORT_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [EXPORT_BTN],
    resizeObservables: [EXPORT_BTN],
  },
  {
    selector: RESTORE_BTN,
    content: t("tour.user-management.restore-button"),
    tourOpen: openAdvancedMenu,
    tourWaitFor: RESTORE_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [RESTORE_BTN],
    resizeObservables: [RESTORE_BTN],
  },
  // --- CreateUserFromDeletedUsersDialog ---
  {
    selector: RESTORE_DIALOG,
    content: t("tour.user-management.restore-dialog"),
    tourOpen: openRestoreDialogFlow,
    tourWaitFor: RESTORE_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [RESTORE_DIALOG],
    resizeObservables: [RESTORE_DIALOG],
  },
  {
    selector: RESTORE_TABLE,
    content: t("tour.user-management.restore-table"),
    tourOpen: openRestoreDialogFlow,
    tourWaitFor: RESTORE_TABLE,
    tourWaitFrames: 1,
    mutationObservables: [RESTORE_TABLE],
  },
  {
    selector: RESTORE_SEND_BTN,
    content: t("tour.user-management.restore-send-button"),
    tourOpen: openRestoreDialogFlow,
    tourWaitFor: RESTORE_SEND_BTN,
    tourWaitFrames: 1,
    mutationObservables: [RESTORE_SEND_BTN],
  },
  {
    selector: INVITE_BTN,
    content: t("tour.user-management.invite-button"),
    // Prev/Next về menu: đóng restore dialog rồi mở lại advanced menu
    tourOpen: () => {
      closeRestoreDialog();
      openAdvancedMenu();
    },
    tourWaitFor: INVITE_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [INVITE_BTN],
    resizeObservables: [INVITE_BTN],
  },
  // --- InviteEmployeesDialogNew ---
  {
    selector: INVITE_DIALOG,
    content: t("tour.user-management.invite-dialog"),
    tourOpen: openInviteEmployeesFlow,
    tourWaitFor: INVITE_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [INVITE_DIALOG],
    resizeObservables: [INVITE_DIALOG],
  },
  {
    selector: INVITE_TABLE,
    content: t("tour.user-management.invite-table"),
    tourOpen: openInviteEmployeesFlow,
    tourWaitFor: INVITE_TABLE,
    tourWaitFrames: 1,
    mutationObservables: [INVITE_TABLE],
  },
  {
    selector: INVITE_NEW_USER_BTN,
    content: t("tour.user-management.invite-new-user-button"),
    tourOpen: openInviteEmployeesFlow,
    tourWaitFor: INVITE_NEW_USER_BTN,
    tourWaitFrames: 1,
    mutationObservables: [INVITE_NEW_USER_BTN],
  },
  // --- InviteNewUserDialog (nested) ---
  {
    selector: INVITE_NEW_USER_DIALOG,
    content: t("tour.user-management.invite-new-user-dialog"),
    tourOpen: openInviteNewUserFlow,
    tourWaitFor: INVITE_NEW_USER_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [INVITE_NEW_USER_DIALOG],
    resizeObservables: [INVITE_NEW_USER_DIALOG],
  },
  {
    selector: INVITE_NEW_USER_INPUT,
    content: t("tour.user-management.invite-new-user-input"),
    tourOpen: openInviteNewUserFlow,
    tourWaitFor: INVITE_NEW_USER_INPUT,
    tourWaitFrames: 1,
    mutationObservables: [INVITE_NEW_USER_INPUT],
  },
  {
    selector: INVITE_NEW_USER_TABLE,
    content: t("tour.user-management.invite-new-user-table"),
    tourOpen: openInviteNewUserFlow,
    tourWaitFor: INVITE_NEW_USER_TABLE,
    tourWaitFrames: 1,
    mutationObservables: [INVITE_NEW_USER_TABLE],
  },
  {
    selector: INVITE_NEW_USER_SEND,
    content: t("tour.user-management.invite-new-user-send"),
    tourOpen: openInviteNewUserFlow,
    tourWaitFor: INVITE_NEW_USER_SEND,
    tourWaitFrames: 1,
    mutationObservables: [INVITE_NEW_USER_SEND],
  },
  // --- User detail: Edit / status menu / tabs ---
  {
    selector: EDIT_BTN,
    content: t("tour.user-management.edit-button"),
    tourOpen: goToDetailTab,
    tourWaitFor: EDIT_BTN,
    tourWaitFrames: 1,
    mutationObservables: [EDIT_BTN],
  },
  {
    selector: EDIT_DIALOG,
    content: t("tour.user-management.edit-dialog"),
    tourOpen: openEditUserFlow,
    tourWaitFor: EDIT_DIALOG,
    tourWaitFrames: 1,
    mutationObservables: [EDIT_DIALOG],
    resizeObservables: [EDIT_DIALOG],
    actionAfter: () => {
      closeEditUserDialog();
    },
  },
  {
    selector: SHOW_EVENT_BTN,
    content: t("tour.user-management.show-event-button"),
    tourOpen: openUserStatusMenuFlow,
    tourWaitFor: SHOW_EVENT_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [SHOW_EVENT_BTN],
    resizeObservables: [SHOW_EVENT_BTN],
  },
  {
    selector: TERMINATE_BTN,
    content: t("tour.user-management.terminate-button"),
    tourOpen: openUserStatusMenuFlow,
    tourWaitFor: TERMINATE_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [TERMINATE_BTN],
    resizeObservables: [TERMINATE_BTN],
  },
  {
    selector: REMOVE_BTN,
    content: t("tour.user-management.remove-button"),
    tourOpen: openUserStatusMenuFlow,
    tourWaitFor: REMOVE_BTN,
    tourWaitFrames: 1,
    tourStableFrames: 2,
    mutationObservables: [REMOVE_BTN],
    resizeObservables: [REMOVE_BTN],
  },
  {
    selector: DETAIL_TAB,
    content: t("tour.user-management.detail-tab"),
    tourOpen: goToDetailTab,
    tourWaitFor: DETAIL_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: DEVICE_TAB,
    content: t("tour.user-management.device-tab"),
    tourOpen: goToDeviceTab,
    tourWaitFor: DEVICE_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: USERGROUP_TAB,
    content: t("tour.user-management.usergroup-tab"),
    tourOpen: goToUserGroupTab,
    tourWaitFor: USERGROUP_TAB,
    tourWaitFrames: 1,
  },
  {
    selector: LEAVE_TAB,
    content: t("tour.user-management.leave-tab"),
    tourOpen: goToLeaveTab,
    tourWaitFor: LEAVE_TAB,
    tourWaitFrames: 1,
  },
];
